module.exports = __webpack_public_path__ + "img/06-29-176.6bec0413.jpg";